
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IconsComponent } from '../../icons/icons.component'

@Component({
    selector: 'pulse-animation-component',
    templateUrl: './pulse-animation.component.html',
    styleUrls: ['./pulse-animation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    IconsComponent
]
})
export class PulseAnimationComponent {
  @Input({ required: true })
  public icon?: string
}
